"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _pittaModules = require("@thingsw/pitta-modules");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyle = (0, _styles.makeStyles)({
  root: {
    color: _pittaModules.LightColors.primary['4'],
    padding: 3,
    '&.Mui-disabled': {
      color: function color(props) {
        return props.checked ? "".concat(_pittaModules.LightColors.primary['7'], "5A") : "".concat(_pittaModules.LightColors.primary['4'], "5A");
      }
    },
    '&.MuiCheckbox-indeterminate	': {
      color: _pittaModules.LightColors.primary['7']
    }
  }
});
var LightCheckedIcon = function LightCheckedIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_7584_163406)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "5",
    y: "5",
    width: "14",
    height: "14",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.98437 17.0156L18.9844 8.01563L17.5781 6.5625L9.98437 14.1563L6.42187 10.5938L5.01562 12L9.98437 17.0156ZM18.9844 3C19.5469 3 20.0156 3.20313 20.3906 3.60938C20.7969 3.98438 21 4.45313 21 5.01563L21 18.9844C21 19.5469 20.7969 20.0313 20.3906 20.4375C20.0156 20.8125 19.5469 21 18.9844 21L5.01562 21C4.45312 21 3.96875 20.8125 3.5625 20.4375C3.1875 20.0313 3 19.5469 3 18.9844L3 5.01563C3 4.45313 3.1875 3.98438 3.5625 3.60938C3.96875 3.20313 4.45312 3 5.01562 3L18.9844 3Z",
    fill: "#13131C"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_7584_163406"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var LightUnCheckedIcon = function LightUnCheckedIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_7584_163260)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.9844 3C19.5156 3 19.9844 3.20313 20.3906 3.60938C20.7969 4.01563 21 4.48438 21 5.01563L21 18.9844C21 19.5156 20.7969 19.9844 20.3906 20.3906C19.9844 20.7969 19.5156 21 18.9844 21L5.01562 21C4.48437 21 4.01562 20.7969 3.60937 20.3906C3.20312 19.9844 3 19.5156 3 18.9844L3 5.01563C3 4.48438 3.20312 4.01563 3.60937 3.60938C4.01562 3.20313 4.48437 3 5.01562 3L18.9844 3ZM18.9844 5.01563L5.01562 5.01563L5.01562 18.9844L18.9844 18.9844L18.9844 5.01563Z",
    fill: "#D4D4D5"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_7584_163260"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var LightIndeterminateIcon = function LightIndeterminateIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_7584_157487)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "5",
    y: "5",
    width: "14",
    height: "14",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.0156 12.9844L17.0156 11.0156L6.98437 11.0156L6.98437 12.9844L17.0156 12.9844ZM18.9844 3C19.5156 3 19.9844 3.20313 20.3906 3.60938C20.7969 4.01563 21 4.48438 21 5.01563L21 18.9844C21 19.5156 20.7969 19.9844 20.3906 20.3906C19.9844 20.7969 19.5156 21 18.9844 21L5.01562 21C4.48437 21 4.01562 20.7969 3.60937 20.3906C3.20312 19.9844 3 19.5156 3 18.9844L3 5.01563C3 4.48438 3.20312 4.01563 3.60937 3.60938C4.01562 3.20313 4.48437 3 5.01562 3L18.9844 3Z",
    fill: "#13131C"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_7584_157487"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var DarkCheckedIcon = function DarkCheckedIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5864_50252)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "5",
    y: "5",
    width: "14",
    height: "14",
    fill: "#121216"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.98437 17.0156L18.9844 8.01563L17.5781 6.5625L9.98437 14.1563L6.42187 10.5938L5.01562 12L9.98437 17.0156ZM18.9844 3C19.5469 3 20.0156 3.20313 20.3906 3.60938C20.7969 3.98438 21 4.45313 21 5.01563L21 18.9844C21 19.5469 20.7969 20.0313 20.3906 20.4375C20.0156 20.8125 19.5469 21 18.9844 21L5.01562 21C4.45312 21 3.96875 20.8125 3.5625 20.4375C3.1875 20.0313 3 19.5469 3 18.9844L3 5.01563C3 4.45313 3.1875 3.98438 3.5625 3.60938C3.96875 3.20313 4.45312 3 5.01562 3L18.9844 3Z",
    fill: "#EEEEF3"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5864_50252"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var DarkUnCheckedIcon = function DarkUnCheckedIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5863_71259)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.9844 3C19.5156 3 19.9844 3.20312 20.3906 3.60938C20.7969 4.01563 21 4.48438 21 5.01562V18.9844C21 19.5156 20.7969 19.9844 20.3906 20.3906C19.9844 20.7969 19.5156 21 18.9844 21H5.01562C4.48438 21 4.01562 20.7969 3.60938 20.3906C3.20312 19.9844 3 19.5156 3 18.9844V5.01562C3 4.48438 3.20312 4.01563 3.60938 3.60938C4.01562 3.20312 4.48438 3 5.01562 3H18.9844ZM18.9844 5.01562H5.01562V18.9844H18.9844V5.01562Z",
    fill: "#636367"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5863_71259"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "18",
    height: "18",
    fill: "white",
    transform: "translate(3 3)"
  }))));
};
var DarkIndeterminateIcon = function DarkIndeterminateIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5864_50225)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.0156 12.9844L17.0156 11.0156L6.98437 11.0156L6.98437 12.9844L17.0156 12.9844ZM18.9844 3C19.5156 3 19.9844 3.20313 20.3906 3.60938C20.7969 4.01563 21 4.48438 21 5.01563L21 18.9844C21 19.5156 20.7969 19.9844 20.3906 20.3906C19.9844 20.7969 19.5156 21 18.9844 21L5.01562 21C4.48437 21 4.01562 20.7969 3.60937 20.3906C3.20312 19.9844 3 19.5156 3 18.9844L3 5.01563C3 4.48438 3.20312 4.01563 3.60937 3.60938C4.01562 3.20313 4.48437 3 5.01562 3L18.9844 3Z",
    fill: "#EEEEF3"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5864_50225"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var CheckBox = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = useStyle(props);
  var checkedIcon = props.checkedIcon ? props.checkedIcon : props.darkMode ? /*#__PURE__*/_react.default.createElement(DarkCheckedIcon, null) : /*#__PURE__*/_react.default.createElement(LightCheckedIcon, null);
  return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
    checkedIcon: checkedIcon,
    icon: props.darkMode ? /*#__PURE__*/_react.default.createElement(DarkUnCheckedIcon, null) : /*#__PURE__*/_react.default.createElement(LightUnCheckedIcon, null),
    ref: ref,
    classes: classes,
    indeterminateIcon: props.darkMode ? /*#__PURE__*/_react.default.createElement(DarkIndeterminateIcon, null) : /*#__PURE__*/_react.default.createElement(LightIndeterminateIcon, null)
  }, props));
});
exports.CheckBox = CheckBox;